import { BASKET_API, BasketApi } from 'components/ordering/multiple-baskets/basket-api/basket-api.js'
import { User } from 'components/ordering/multiple-baskets/basket-api/user.js'
import {
  BasketListItem,
  mapBasketListResponse,
  mapSelectedBasketFromResponse
} from 'components/ordering/multiple-baskets/basket-store/basket-list-parser.js'
import { createComputed, createSignal } from '@cloudsuite/mosaic-shared/scripts/signals.js'
import { FAKE, inject, REAL, registerDependency } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import { BasketList, NoBasketSelected } from 'components/ordering/acl/internal-types.js'


const [rawBasketList, setRawBasketList] = createSignal(new BasketList([], new NoBasketSelected()))

export const BASKET_LIST_MUTATOR = Symbol('BASKET_LIST_MUTATOR')
export type BasketListMutator = {
  initialize: (user: User) => void
  refreshBasketList: () => void
}


@registerDependency(REAL, BASKET_LIST_MUTATOR)
@registerDependency(FAKE, BASKET_LIST_MUTATOR)
export class ConcreteBasketListMutator implements BasketListMutator {
  @inject(BASKET_API)
  private basketApi!: BasketApi

  private user?: User

  private readonly initialization: Promise<void>
  private resolveInitialization!: () => void

  constructor() {
    this.initialization = new Promise(resolve => this.resolveInitialization = resolve)
  }

  initialize = (user: User) => {
    if (this.user !== undefined) return

    this.user = user

    this.resolveInitialization()
    this.refreshBasketList()
  }

  refreshBasketList = async () => {
    await this.initialization

    if (this.user === undefined) {
      throw new Error('BasketListMutator not properly initialized')
    }

    setRawBasketList(await this.basketApi.getBasketList(this.user))
  }
}


export const BASKET_LIST_STORE = Symbol('BASKET_LIST_STORE')
export type BasketListStore = {
  basketList: () => BasketListItem[]
  selectedBasket: () => BasketListItem | null
}

@registerDependency(REAL, BASKET_LIST_STORE)
@registerDependency(FAKE, BASKET_LIST_STORE)
export class ConcreteBasketListStore implements BasketListStore {
  basketList = createComputed(() => mapBasketListResponse(rawBasketList()))
  selectedBasket = createComputed(() => mapSelectedBasketFromResponse(rawBasketList()))
}
